module.exports = __webpack_public_path__ + "media/2-32.a0174ea0.wav";